import React, { Component } from 'react';
import axios from 'axios';
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";

import classes from './UserButton.module.css';
import PersonRounded from '@material-ui/icons/PersonRounded';
import apiUrl from "../../../shared/config";
import * as actionTypes from "../../../store/actions/actionTypes";
import {connect} from "react-redux";
import {getDisplayName} from "../../../utils/utils";


class UserButton extends Component {

    state = {
        user: {
            first_name: 'Loading...',
            last_name: '',
            display_name: this.props.display_name,
            user_contact_email: 'Private',
            groups: [
                {
                    group_id: null,
                    group_manager: 0,
                    group_name: '',
                    group_type_name: '',
                    group_type_description: '',
                    group_user_type_name: '',
                    group_user_type_description: ''
                }
            ]
        }
    };

    source = axios.CancelToken.source();
    _isMounted = false;

    componentDidMount() {
        this._isMounted = true;
        if (this.props.userId) {
            axios.get(apiUrl +'Users/getUserById?user_id=' + this.props.userId)
                .then(response => {
                    if (this._isMounted) {
                        this.setState({user: response.data});
                    }
                })
                .catch(error => {
                if (axios.isCancel(error)) {
                    console.log('Request canceled', error.message);
                } else {
                    console.error("There was an error fetching the user data:", error);
                }
            });
        }
        else if (this.state.pattern && this.props.id === null) {
            this.setState({pattern: null});
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userEditOpen !== this.props.userEditOpen) {
            console.log('called')
            axios.get(apiUrl +'Users/getUserById?user_id=' + this.props.userId)
                .then(response => {
                    if (this._isMounted) {
                        this.setState({user: response.data});
                    }
                })
                .catch(error => {
                if (axios.isCancel(error)) {
                    console.log('Request canceled', error.message);
                } else {
                    console.error("There was an error fetching the user data:", error);
                }
            });
        }
    }

    componentWillUnmount() {
        // cancel pending api calls
        this._isMounted = false;
        this.source.cancel("Component unmounted, request cancelled");
    }

    viewUser = () => {
        this.props.setSelectedUserId(this.props.userId);
        this.props.onOpenModal();
    }

    getDisplayName() {
        return getDisplayName(this.state.user.display_name, this.state.user.first_name, this.state.user.last_name)
    }


    render() {
        const user_text = this.state.user.first_name+' '+this.state.user.last_name;

        const groups_jsx = this.state.user.groups.map( group => {
            const member_text = group.group_manager ? ' and Group Manager for' : ' at';
            const group_type_name = (group.group_type_name ? group.group_type_name.toLowerCase() : '');
            const group_text = group.group_id ? group.group_user_type_name+member_text+' the '+group_type_name+' '+group.group_name+'.' : '';

            return (<li key={group.group_id}>{group_text}</li>);
        });


        return (
            <OverlayTrigger
                trigger={['hover', 'focus']}
                rootClose
                rootCloseEvent="click"
                key={this.state.user.user_id}
                placement='bottom'
                overlay={
                    <Popover id={classes.UserDetails}>
                        <Popover.Title as="h3"><PersonRounded />{this.state.user.display_name}</Popover.Title>
                        <Popover.Content className="pattern-exercise-description">
                            {user_text}
                            <ul>{groups_jsx}</ul>
                            <div>{this.state.user.user_contact_email}</div>
                            <div className={classes.info}>Click above to view/edit user profile.</div>
                        </Popover.Content>
                    </Popover>
                }
            >
                <div
                    className={`${this.props.isInNavbar ? classes.navbarUser : classes.user} ${classes.clickable}`}
                    key={this.props.user_id}
                    onClick={this.viewUser}
                >
                    <PersonRounded/>{this.getDisplayName()}
                </div>
            </OverlayTrigger>

        );
    }
}

const mapStateToProps = state => {
    return {
        loggedInUser: state.auth.userId
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onOpenModal: () => dispatch({type: actionTypes.OPEN_USER_MODAL}),
        setSelectedUserId: (userId) => dispatch({type: actionTypes.SELECT_USER, userId: userId})
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserButton);